import script from "./AdminDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__